"use client"

import { memo } from "react"
import AlbumPlayButton from "./AlbumPlayButton"

type Props = {
  imgUrl?: string
  title?: string
  loaded: boolean
  setLoaded: (v: boolean) => void
  show: boolean
  isPlaying: boolean
  onPlay: (e: React.MouseEvent<HTMLButtonElement>) => void
}

function AlbumImage({
  imgUrl,
  title,
  loaded,
  setLoaded,
  show,
  isPlaying,
  onPlay,
}: Props) {
  return (
    <div className="relative w-20 h-20 flex-shrink-0">
      <img
        src={imgUrl}
        alt={title}
        className="w-full h-full object-cover"
        onLoad={() => setLoaded(true)}
        onError={(e) => {
          ;(e.target as HTMLImageElement).src = "/fallback.jpg"
        }}
      />

      {!loaded && (
        <div className="absolute inset-0 bg-black/20 animate-pulse" />
      )}

      <AlbumPlayButton
        show={show}
        isPlaying={isPlaying}
        onPlay={onPlay}
      />
    </div>
  )
}

export default memo(AlbumImage)